var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.3125C13.5 5.13281 12.3047 3.09375 10.4062 1.96875C8.47266 0.878906 6.11719 0.878906 4.21875 1.96875C2.28516 3.09375 1.125 5.13281 1.125 7.3125C1.125 9.52734 2.28516 11.5664 4.21875 12.6914C6.11719 13.7812 8.47266 13.7812 10.4062 12.6914C12.3047 11.5664 13.5 9.52734 13.5 7.3125ZM12.0586 12.8672C10.793 13.9922 9.10547 14.625 7.3125 14.625C3.26953 14.625 0 11.3555 0 7.3125C0 3.30469 3.26953 0 7.3125 0C11.3203 0 14.625 3.30469 14.625 7.3125C14.625 9.14062 13.957 10.793 12.8672 12.0938L17.8242 17.0508C18.0352 17.2617 18.0352 17.6484 17.8242 17.8594C17.6133 18.0703 17.2266 18.0703 17.0156 17.8594L12.0586 12.8672Z",
    fill: "#50638E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.932d7d57107b2c34278b917f000566e1.svg";
export { ForwardRef as ReactComponent };